import React from 'react';
import {useSearchParams} from 'react-router-dom';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import environmentStore from '@di-shared/features/environment/environmentStore';
import VehicleInspectionEditVehicle from '@di-shared/features/public-service/vehicle-inspection/VehicleInspectionEditVehicle';

interface VehicleInspectionEditVehiclePageProps {
  vin: string;
}

function VehicleInspectionEditVehiclePage({vin}: VehicleInspectionEditVehiclePageProps) {
  const {t} = useInferableTranslation();
  const [params] = useSearchParams();
  const index = params.get('index') || 0;
  /**
   * [2025-10-02:Jeyoung Lee] FIXME: index 없을 때 처리? + error 처리 ?
   */
  const puid = environmentStore.getState().puid;
  return (
    <div className="wrap">
      <Header right={<HeaderCloseButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T30527')}</h1>
      </Header>
      <VehicleInspectionEditVehicle
        selectedIndex={+index}
        puid={puid}
        vin={vin}
      />
    </div>
  );
}

export default VehicleInspectionEditVehiclePage;
